import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function AdminFlags() {
  const [flags, setFlags] = useState([]);
  const load = () => api.get("/admin/flags").then((r) => setFlags(r.data));
  useEffect(() => { load(); }, []);
  const act = async (id, action) => { await api.patch(`/admin/flags/${id}`, { action }); toast.success(action); load(); };
  return (
    <div className="container-x py-12" data-testid="admin-flags-page">
      <Seo title="Moderation" noindex/>
      <h1 className="font-serif text-4xl">Moderation queue</h1>
      <p className="text-black/60 mt-2">{flags.length} open flags.</p>
      <div className="space-y-3 mt-8">
        {flags.map((f) => (
          <div key={f.id} className="card" data-testid={`flag-${f.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <span className="badge badge-warning">{f.target_type}</span>
                <span className="text-xs text-black/60 ml-2">by {f.reporter_name} · {new Date(f.created_at).toLocaleString()}</span>
              </div>
              <div className="flex gap-2">
                <button onClick={()=>act(f.id, "dismiss")} className="btn-outline" data-testid={`dismiss-${f.id}`}>Dismiss</button>
                <button onClick={()=>act(f.id, "remove")} className="btn-filled" data-testid={`remove-${f.id}`}>Remove content</button>
              </div>
            </div>
            {f.preview && (
              <div className="mt-3 text-sm border-l-[0.5px] border-black/20 pl-3">
                {f.preview.title && <div className="font-medium">{f.preview.title}</div>}
                {f.preview.body && <div className="text-black/70">{f.preview.body}</div>}
                {f.preview.slug && <Link to={`/blog/${f.preview.slug}`} className="text-xs underline">View post</Link>}
              </div>
            )}
          </div>
        ))}
        {flags.length === 0 && <p className="text-black/50">No open flags.</p>}
      </div>
    </div>
  );
}
